// This is just an example,
// so you can safely delete all default props below
import strings from './en-gb.json';
export default strings;
